module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ProductTabs'), _vm._v(" "), _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "title": ("" + (_vm.$t('pages.by_category_product'))),
      "rows": _vm.storageCountries,
      "isFixed": true
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-729da737"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/product/ProductTag.vue
// module id = 578
// module chunks = 0